import React from 'react';
import io from 'socket.io-client';
import { Observable } from 'rxjs';

const eventNames = [
  'auction-ended',
  'auction-started',
  'bid-placed',
  'user-connected',
  'user-disconnected',
];

export const path = '/ioimpl/socket.io';
export const SocketContext = React.createContext(null);

const noop = () => {};

const defaultContextValue = {
  connected: false,
  socket: null,
  subscribe: noop,
  unsubscribe: noop,
};

const SocketProvider = ({ children }) => {
  const socket = React.useRef(null);
  const subscriptions = React.useRef({});

  const unsubscribeAll = () => {
    Object.values(subscriptions.current).forEach(sub => {
      if (typeof sub.unsubscribe === 'function') sub.unsubscribe();
    });
    subscriptions.current = {};
  };

  const [contextValue, setContextValue] = React.useState({
    ...defaultContextValue,
    connect: user => {
      socket.current = io('/', {
        query: {
          name: encodeURIComponent(user.Username),
          token: localStorage.getItem('ACCESS_TOKEN'),
        },
        transports: ['websocket'],
      });

      // socket.current.on('error', () => console.log('error'));
      // socket.current.on('connect_error', () => console.log('connect_error'));
      // socket.current.on('connect_timeout', () =>
      //   console.log('connect_timeout')
      // );
      // socket.current.on('reconnect', () => console.log('reconnect'));
      // socket.current.on('reconnecting', () => console.log('reconnecting'));
      // socket.current.on('reconnect_error', () =>
      //   console.log('reconnect_error')
      // );
      // socket.current.on('reconnect_failed', () =>
      //   console.log('reconnect_failed')
      // );
      socket.current.on('reconnect_attempt', () => {
        socket.current.io.opts.transports = ['polling', 'websocket'];
      });
      socket.current.on('connect_error', unsubscribeAll);
      socket.current.on('connect', () => {
        setContextValue(currentValue => ({
          ...currentValue,
          connected: true,
          send: (...args) => {
            socket.current.emit(...args);
          },
          socket: socket.current,
          subscribe: (eventName, callback) => {
            if (!eventNames.includes(eventName))
              console.error(
                'CAUTION: Subscribing to invalid event',
                eventName,
                new Error()
              );

            if (
              subscriptions.current[eventName] &&
              typeof subscriptions.current[eventName].unsubscribe === 'function'
            ) {
              subscriptions.current[eventName].unsubscribe();
              delete subscriptions.current[eventName];
            }

            subscriptions.current[eventName] = Observable.fromEvent(
              socket.current,
              eventName
            ).subscribe(callback);
          },
          unsubscribe: eventNames => {
            const evts = Array.isArray(eventNames)
              ? eventNames
              : typeof eventNames === 'string'
              ? [eventNames]
              : [];

            for (let eventName of evts) {
              if (subscriptions.current[eventName]) {
                subscriptions.current[eventName].unsubscribe();
                delete subscriptions.current[eventName];
              }
            }
          },
        }));
      });
    },
    disconnect: () => {
      socket.current.disconnect();
      socket.current = null;

      unsubscribeAll();

      setContextValue(value => ({ ...value, ...defaultContextValue }));
    },
  });

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
